module.exports = __webpack_public_path__ + "img/icon_board.404bcd7f.svg";